import * as React from "react"

const _NoseShort = ({ isEditor }: { isEditor: boolean }) => {
  return (
    <svg
      style={{
        width: !isEditor ? "10%" : "60%",
        height: !isEditor ? "10%" : "60%",
        position: "absolute",
        top: !isEditor ? "15%" : "20%",
        left: !isEditor ? "46%" : "30%"
      }}
      width="32"
      height="40"
      viewBox="0 0 32 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.5 7C16.1667 10.8333 16.5 19.2 20.5 22C25.5 25.5 20 34 10 32"
        stroke="#171921"
        strokeWidth="4"
      />
    </svg>
  )
}

export const NoseShort = React.memo(_NoseShort)
